import { render, staticRenderFns } from "./PartnerHub.vue?vue&type=template&id=18fb8008"
import script from "./PartnerHub.vue?vue&type=script&lang=js"
export * from "./PartnerHub.vue?vue&type=script&lang=js"
import style0 from "./PartnerHub.vue?vue&type=style&index=0&id=18fb8008&prod&media=screen&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports